/*
 * @providesModule InterstitialConstants
 */

export const Interstitials = {
  VISIT_PLAY_TAB: 'VISIT_PLAY_TAB',
  FTUE_START: 'FTUE_END', // TODO: Replace this with the actual FTUE_START trigger
  POST_FTUE_END: 'FTUE_END',
  POST_DEPOSIT: 'DEPOSIT', //successful
  POST_CANCEL_DEPOSIT: 'CANCEL_DEPOSIT',
  POST_WITHDRAWAL: 'WITHDRAWAL', // closing confirmation
  POST_CASH_MATCH_WIN: 'CASH_MATCH_WIN',
  POST_CASH_MATCH_LOSS: 'CASH_MATCH_LOSS',
  POST_Z_MATCH_WIN: 'Z_MATCH_WIN',
  POST_Z_MATCH_LOSS: 'Z_MATCH_LOSS',
  POST_Z_MATCH_END: 'Z_MATCH_END',
  POST_CLAIM_TROPHY: 'CLAIM_TROPHY',
  POST_CLAIM_FREE_Z: 'CLAIM_FREE_Z',
  POST_CLAIM_LOGIN_BONUS: 'CLAIM_LOGIN_BONUS',
  POST_CLAIM_DAILY_CHALLENGES: 'CLAIM_DAILY_CHALLENGES',
};

export const INTERSTITIALS_PREFERENCE_TIMESTAMP = 'interstitials_preference_timestamp';
export const DAILY_BONUS_CASH_SCREEN_LAST_VISIT_TIMESTAMP = 'daily_bonus_cash_screen_last_visit_timestamp';
export const DAILY_BONUS_CASH_SCREEN_REDIRECT_COUNT = 'daily_bonus_cash_screen_redirect_count';
export const DAILY_BONUS_CASH_SCREEN_REDIRECT_COUNT_RESET_TIMESTAMP = 'daily_bonus_cash_screen_redirect_count_reset_timestamp';
